<template>
  <div>
    <!-- 日历票授权弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="日历票授权"
      :visible.sync="defailDialogVisible"
      :before-close="defailHandleClose"
      width="80%"
      center
    >
      <el-divider></el-divider>
      <div class="athorTitle">
        <el-button  @click="fun_date(-7,dateWeek.monday)">上一周</el-button>
        <el-button @click="fun_date(7,dateWeek.monday)">下一周</el-button>
        <el-input placeholder="产品名称" v-model="data.name"></el-input>
        <el-button class="btnTitle" @click="dataCx">查询</el-button>
      </div>
      <div class="authorTable">
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="商品名称" width="120">
            <template slot-scope="scope">{{ scope.row.ProductName }}</template>
          </el-table-column>
          <el-table-column prop="numberflag" :label="dateWeek.monday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.monday.substring(0,10)">
                 <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
            </template>
          </el-table-column>
         <el-table-column prop="agentprice" :label="dateWeek.tuesday" width="150">
          <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.tuesday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
         </el-table-column>
           <el-table-column prop="name" :label="dateWeek.wednesday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.wednesday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
          </el-table-column>
          <el-table-column prop="name" :label="dateWeek.thursday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.thursday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
          </el-table-column>
          <el-table-column prop="name" :label="dateWeek.friday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.friday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
          </el-table-column>
          <el-table-column prop="name" :label="dateWeek.staturday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.staturday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
          </el-table-column>
           <el-table-column prop="name" :label="dateWeek.sunday" width="150">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.sunday.substring(0,10)">
                <div class="disFlex"> 数量：<el-input v-model="item.daynumber"  @blur="NumberF(item)"></el-input>
                 </div>
                 <div class="disFlex"> 价格：<el-input v-model="item.agentprice" @blur="NumberP(item)"></el-input></div>
              </div>
          </template>
          </el-table-column> 
          <el-table-column prop="name" label="日库存" width="150">
            <template slot-scope="scope">
                <div v-if="scope.row.is_impower=='1'">
                  <el-input v-model="scope.row.DayNumber" @blur="NumberDay(scope.row)"></el-input>
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" @click="plSetFn(scope.row)">批量设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" 
            :page-size="data.page_size" :current-page="data.page" @current-change="curren"></el-pagination>
      </div>
      <div class="itemBtnS">
        <el-button class="btnL" @click="clearsBnt">取消授权</el-button>
        <el-button class="btnL" @click="setempower">确认授权</el-button>
      </div>
    </el-dialog>
    <!-- 日历票授权弹框结束 -->
    <!-- 批量设置弹框开始 -->

    <el-dialog :close-on-click-modal="false"
      title="日历批量授权"
      :visible.sync="plSetDialogVisible"
      :before-close="plSetHandleClose"
      width="36.1%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="100px" :model="form">
        <div class="flexDis itemInp">
          <el-form-item label="日期:">
            <span class="absPosiA">*</span>
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="星期:">
          <span class="absPosiA">*</span>
          <div class="disX">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            >每日</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="结算价:">
          <span class="absPosiB">*</span>
          <el-input v-model="price" placeholder="请输入结算价"></el-input>
          <span class="dw">元</span>
        </el-form-item>
        <el-form-item class="itemBtnS">
          <el-button class="btnL" @click="getDates">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 批量设置弹框结束 -->
  </div>
</template>

<script>
import {saveDistrbutorTwoDayNumber,getDistributortwoCldList,batchCldProduct,cancelImpowerDistrbutorTwoProduct,impowerDistrbutorTwoProductCld,getProductInfo,aloneDistrbutorTwoCldProduct} from "@/request/distributor.js"
import { Message } from "element-ui";
const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
export default {
  props:['row'],
  data() {
    return {
      loading:true,
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      defailDialogVisible: false, // 日历票授权
      plSetDialogVisible: false, // 日历批量授权
      dateWeek: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        staturday: "",
        sunday: ""
      },
      tableData: [
      ],
      multipleSelection: [],
      options: [
      ],
      form: {
      },
      value1: "",
      value: "",
      value2: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        distributortwoid:'',
        startTime:'',
        endTime:'',
        page:1,
        total:1,
        page_size:8,
        name:''
      },
      Daterow:'',
      price:'',
      yesid:'',
      noid:'',
      idtotal:0,
      dataId:'',
      day1:'',
      day2:''
    };
  },
  mounted() {
    this.getMondayAndSunday()
    this.getList()
  },
  methods: {
    NumberDay(item){
      if(item.dayNumb==item.DayNumber){
         Message.error('数量未修改')
         return false
      }
      item.dayNumb = item.DayNumber
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwoid:this.row.DistributorID,
        day_number:item.DayNumber,
        ProductID:item.ProductID
      }
      saveDistrbutorTwoDayNumber(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('修改成功')
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    NumberF(item){
      if(item.day3==item.daynumber){
        Message.error('数量未修改')
        return false
      }
      if(this.day1==item.daynumber){
        Message.error('数量未修改')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwoid:this.row.DistributorID,
        ProductID:item.productid,
        day:item.date,
        stock:item.daynumber,
        agentprice:item.agentprice
      }
      this.day1 = item.daynumber
      this.day2 = item.agentprice
      aloneDistrbutorTwoCldProduct(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('修改成功')
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    NumberP(item){
      if(item.day4==item.agentprice){
        Message.error('价格未修改')
        return false
      }
      if(this.day2==item.agentprice){
        Message.error('价格未修改')
        return false
      }
      if(item.agentprice<=0){
        Message.error('价格不能小于0')
        this.getList()
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwoid:this.row.DistributorID,
        ProductID:item.productid,
        day:item.date,
        stock:item.daynumber,
        agentprice:item.agentprice
      }
      this.day1 = item.daynumber
      this.day2 = item.agentprice
      aloneDistrbutorTwoCldProduct(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('修改成功')
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    fun_date(num, data) {
      this.loading =true
      let date1 = new Date(data.slice(0,data.length-1));
      //今天时间
      let time1 =
        date1.getFullYear() +
        "-" +
        (date1.getMonth() + 1) +
        "-" +
        date1.getDate();
        let date2 = new Date(date1);
        date2.setDate(date1.getDate() + num);
        //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
        let time2 =
          date2.getFullYear() +
          "-" +
          (date2.getMonth() + 1) +
          "-" +
          date2.getDate();
        this.getMondayAndSunday(time2)
        this.getList()
    },
    dataCx(){
      this.loading = true
      this.data.page = 1
      this.total = 0
      this.getList()
    },
   // 分页
   curren(e){
    this.loading = true
    this.data.page = e
    this.getList()
   },
    // 获取日历票详情数据
    getList(){
        this.data.distributortwoid=this.row.DistributorID,
        this.data.startTime=this.dateWeek.monday.substring(0,10),
        this.data.endTime=this.dateWeek.sunday.substring(0, 10)
       getDistributortwoCldList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.dataId = res.data.result.ProductID
          this.tableData = res.data.result.data.data
          this.data.total = res.data.result.data.total
          this.tableData.map(item=>{
            item.dayNumb=item.DayNumber
            item.cld_list.map(itm=>{
              itm.day3 = itm.daynumber
              itm.day4 = itm.agentprice
            })
            if(item.is_impower=='1'){
              this.$nextTick(()=>{
                this.$refs.multipleTable.toggleRowSelection(item, true)
              })
            }
          })
          this.loading = false
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 周全选
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 点击批量设置
    plSetFn(row) {
      this.value1  = []
      this.price = ''
      this.checkAll = false
      this.checkedCities = []
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:row.ProductID
      }
      getProductInfo(data).then(res=>{
          if(res.data.status=='ok'){
            this.value1 = [res.data.result.ConsumeBeginDate,res.data.result.ConsumeEndDate]
            this.price = res.data.result.AgentPrice
            JSON.parse(res.data.result.weeks).map(item=>{
              switch (item) {
                  case '1':
                  this.checkedCities.push('星期一')
                      break
                  case '2':
                  this.checkedCities.push('星期二')
                      break
                  case '3':
                  this.checkedCities.push('星期三')
                      break
                  case '4':
                  this.checkedCities.push('星期四')
                      break
                  case '5':
                  this.checkedCities.push('星期五')
                      break
                  case '6':
                  this.checkedCities.push('星期六')
                      break
                  case '7':
                  this.checkedCities.push('星期日')
                      break
                  default:
                    console.log('default')
              }
            })
            if(this.checkedCities.length=='7'){
              this.checkAll = true
            }else{
              this.checkAll = false
            }
          }
      })
      this.plSetDialogVisible = true;
      this.Daterow = row
    },
    getDates(){
      var start_date =''
      var end_date = ''
      if(!this.value1){
        Message.error('请选择时间')
        return false
      }else{
        start_date = this.value1[0]
        end_date = this.value1[1]
      }
      if(this.price ==''){
        Message.error('请输入结算价')
        return false
      }
      var checkedCities= ''
      if(this.checkedCities){
        this.checkedCities.map(item=>{
          switch (item) {
              case '星期一':
                item = '1'
                  break
              case '星期二':
                item = '2'
                  break
              case '星期三':
                item = '3'
                  break
              case '星期四':
                item = '4'
                  break
              case '星期五':
                item = '5'
                  break
              case '星期六':
                item = '6'
                  break
              case '星期日':
                item = '7'
                  break
              default:
                console.log('default')
          }
          checkedCities += item +',' 
        })
      }
      checkedCities  = checkedCities.substr(0,checkedCities.length - 1);
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:this.row.DistributorID,
        start_date:start_date,
        end_date:end_date,
        week:checkedCities,
        agentprice:this.price,
        ProductID:this.Daterow.ProductID
      }
      batchCldProduct(data).then(res=>{
        if(res.data.status=='ok'){
          this.plSetDialogVisible = false
          this.getList()
          Message.success('操作成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 取消授权
    clearsBnt(){
      if(this.noid==''){
        Message.error('请取消选择授权产品')
        return false
      }
      let id = '';
      [...new Set(this.noid.split(','))].map(item=>{
        if(item){
          id += item + ','
        }
      })
      if (id.length > 0) {
        id  = id.substr(0,id.length - 1);
      }
      console.log(id)
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:this.row.DistributorID,
        ProductID:id
      }
      cancelImpowerDistrbutorTwoProduct(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('取消授权成功')
          this.getList()
          this.yesid=''
          this.noid=''
          this.idtotal=0
          this.dataId=''
          this.multipleSelection = []
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 授权
    setempower(){
      if(this.yesid==''){
        Message.error('请选择授权产品')
        return false
      }
      let dataID = ''
      let id = ''
      if(this.dataId!=''){
        dataID = this.dataId
      }
      [...new Set(this.yesid.split(','))].map(item=>{
        console.log(item)
        if(item){
          id += item + ','
        }
      })
      if (id.length > 0) {
        id  = id.substr(0,id.length - 1);
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:this.row.DistributorID,
        ProductID:id
      }
      impowerDistrbutorTwoProductCld(data).then(res=>{
        if(res.data.status=='ok'){
          this.getMondayAndSunday()
          this.getList()
          Message.success('授权成功')
          this.yesid=''
          this.noid=''
          this.idtotal=0
          this.dataId=''
          this.multipleSelection = []
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 点击批量设置X
    plSetHandleClose() {
      this.plSetDialogVisible = false;
    },
    // 日历票授权
    caldarTct() {
      this.defailDialogVisible = true;
    },
    // 日历票授权X
    defailHandleClose() {
      this.$emit('Distrbutor')
      this.defailDialogVisible = false;
    },
    // 表格全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.idtotal = val.length
      if(this.idtotal!=0&&val.length>=this.idtotal){
        if(val[val.length-1].is_impower=='2'){
          this.yesid +=  val[val.length-1].ProductID + ','
        }
      }
      if(this.multipleSelection.length!=0){
        if(val.length<this.multipleSelection.length){
            if(val.length==0){
                this.noid += this.multipleSelection[0].ProductID + ','
                this.multipleSelection = val;
                this.idtotal = this.multipleSelection.length
                console.log(this.noid)
            }else{
              for(let i=0;i<this.multipleSelection.length;i++){ 
                if(val[i]&&this.multipleSelection[i]){
                  console.log(val[i].ProductID,this.multipleSelection[i].ProductID)
                  if(val[i].ProductID!=this.multipleSelection[i].ProductID){
                    this.noid += this.multipleSelection[i].ProductID + ','
                    i+=1
                  }
                }else{
                  this.noid += this.multipleSelection[i].ProductID + ','
                  i+=1
                }
              }
            }
        }
      }
      this.multipleSelection = val;
    },
    //获取周一到周天的日期
    getMondayAndSunday(data) {
      if(data){
        var now = new Date(data);
      }else{
        var now = new Date(); //获取当前时间（也可以直接用某一天） 计算当前周一和周日
      }
      var nowTime = now.getTime();
      var day = now.getDay();
      var oneDayLong = 24 * 60 * 60 * 1000;

      var MondayTime = nowTime - (day - 1) * oneDayLong;
      var tuesdayTime = nowTime - (day - 2) * oneDayLong;
      var wednesdayTime = nowTime - (day - 3) * oneDayLong;
      var thursdayTime = nowTime - (day - 4) * oneDayLong;
      var fridayTime = nowTime - (day - 5) * oneDayLong;
      var staturdayTime = nowTime - (day - 6) * oneDayLong;
      var sundayTime = nowTime - (day - 7) * oneDayLong;

      if (now.getDay() == 0) {
        //因为周日是比较特殊的，需特别处理
        MondayTime = nowTime - 6 * oneDayLong;
        var tuesdayTime = nowTime - 5 * oneDayLong;
        var wednesdayTime = nowTime - 4 * oneDayLong;
        var thursdayTime = nowTime - 3 * oneDayLong;
        var fridayTime = nowTime - 2 * oneDayLong;
        var staturdayTime = nowTime - 1 * oneDayLong;
        var sundayTime = nowTime - 0 * oneDayLong;
      }
      var monday = new Date(MondayTime);
      var tuesday = new Date(tuesdayTime);
      var wednesday = new Date(wednesdayTime);
      var thursday = new Date(thursdayTime);
      var friday = new Date(fridayTime);
      var staturday = new Date(staturdayTime);
      var sunday = new Date(sundayTime);
      var monday0 = ''
      if((monday.getMonth() + 1)<10){
        monday0 = '0' + (monday.getMonth() + 1)
      }else{
        monday0 =  (monday.getMonth() + 1)
      }
      let monMon = ''
      if(monday.getDate()<10){
        monMon = '0' +monday.getDate()
      }else{
        monMon =  monday.getDate()
      }
      monday =monday.getFullYear() +"-" + monday0 +"-" +monMon;


      var tuseday0 = ''
      if((tuesday.getMonth() + 1)<10){
        tuseday0 = '0' + (tuesday.getMonth() + 1)
      }else{
        tuseday0 =  (tuesday.getMonth() + 1)
      }
      let tuesMon = ''
      if(tuesday.getDate()<10){
        tuesMon = '0' + tuesday.getDate()
      }else{
        tuesMon =  tuesday.getDate()
      }
      tuesday =
        tuesday.getFullYear() +
        "-" +
        tuseday0 +
        "-" +
        tuesMon;


      var wednesday0 = ''
      if( (wednesday.getMonth() + 1)<10){
        wednesday0 = '0' +  (wednesday.getMonth() + 1)
      }else{
        wednesday0 =   (wednesday.getMonth() + 1)
      }
      let wednesMon = ''
      if(wednesday.getDate()<10){
        wednesMon = '0' + wednesday.getDate()
      }else{
        wednesMon =  wednesday.getDate()
      }
      wednesday =
        wednesday.getFullYear() +
        "-" +
        wednesday0 +
        "-" +
        wednesMon;



      var thursday0 = ''
      if((thursday.getMonth() + 1)<10){
        thursday0 = '0' +  (thursday.getMonth() + 1)
      }else{
        thursday0 =   (thursday.getMonth() + 1)
      }
      let thursMon = ''
      if(thursday.getDate()<10){
        thursMon = '0' + thursday.getDate()
      }else{
        thursMon =  thursday.getDate()
      }
      thursday =
        thursday.getFullYear() +
        "-" +
        thursday0 +
        "-" +
        thursMon;


      var friday0 = ''
      if((friday.getMonth() + 1)<10){
        friday0 = '0' + (friday.getMonth() + 1)
      }else{
        friday0 =  (friday.getMonth() + 1)
      }
      let fridayMon = ''
      if(friday.getDate()<10){
        fridayMon = '0' + friday.getDate()
      }else{
        fridayMon =  friday.getDate()
      }
      friday =
        friday.getFullYear() +
        "-" +
        friday0 +
        "-" +
        fridayMon;


      var staturday0 = ''
      if((staturday.getMonth() + 1)<10){
        staturday0 = '0' + (staturday.getMonth() + 1)
      }else{
        staturday0 = (staturday.getMonth() + 1)
      }
      let staturdayMon = ''
      if(staturday.getDate()<10){
        staturdayMon = '0' + staturday.getDate()
      }else{
        staturdayMon =  staturday.getDate()
      }
      staturday =
        staturday.getFullYear() +
        "-" +
        staturday0 +
        "-" +
        staturdayMon;


        var sunday0 = ''
        if((sunday.getMonth() + 1)<10){
          sunday0 = '0' + (sunday.getMonth() + 1)
        }else{
          sunday0 =(sunday.getMonth() + 1)
        }
        let sundayMon = ''
        if(sunday.getDate()<10){
          sundayMon = '0' + sunday.getDate()
        }else{
          sundayMon =  sunday.getDate()
        }
        sunday =
          sunday.getFullYear() +
          "-" +
          sunday0 +
          "-" +
          sundayMon;
      this.dateWeek.monday = monday + "\n" + "一";
      this.dateWeek.tuesday = tuesday + "\n" + "二";
      this.dateWeek.wednesday = wednesday + "\n" + "三";
      this.dateWeek.thursday = thursday + "\n" + "四";
      this.dateWeek.friday = friday + "\n" + "五";
      this.dateWeek.staturday = staturday + "\n" + "六";
      this.dateWeek.sunday = sunday + "\n" + "七";
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.editForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-form-item {
    position: relative;
  }
  .absPosiA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .absPosiB {
    position: absolute;
    top: 0px;
    left: -65px;
    color: #ff4d4f;
  }
  .el-input {
    // width: 500px;
  }
  .dw {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin: 10px;
  }
}
.disX {
  width: 100%;
  // height: 80px;
  display: flex;
  // background: red;
  .el-checkbox {
    margin-right: 20px;
  }
}
/deep/ .el-date-editor{
  width: 100%;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
.athorTitle {
  margin-bottom: 20px;
  .el-button {
    width: 110px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
  }
  .btnTitle {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }
  .el-input {
    width: 240px;
    margin: 0 20px;
  }
  .el-date-editor {
    width: 180px;
    margin: 0 20px;
  }
}
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-left: -100px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.authorTable {
  .el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    -webkit-appearance: none;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    text-align: center;
  }
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
  /deep/.el-table .cell {
    white-space: pre-line;
  }
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.pagination{
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -100px;
}
.disFlex{
    display: flex;
    margin: 1rem 0;
  }
  .disFlex /deep/ .el-input{
    width: 80px !important;
  }
  /deep/.el-dialog {
    min-width: 400px;
  }
  /deep/.has-gutter .el-checkbox{
  display: none;
}
</style>